(function () {
  'use strict';

  if (window.FateSizeFinderAPI) return;

  var BASE_URL = 'https://size-finder-api-production.up.railway.app';
  var SESSION_ID_KEY = 'fate_sf_client_session_v2';
  var SESSION_TOKEN_KEY = 'fate_sf_api_session_v2';
  var ACTIVE_KEY = 'fate_sf_active_recommendation_v2';
  var tokenPromise = null;

  function randomId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    var bytes = new Uint8Array(24);
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') window.crypto.getRandomValues(bytes);
    else for (var index = 0; index < bytes.length; index += 1) bytes[index] = Math.floor(Math.random() * 256);
    return Array.prototype.map.call(bytes, function (value) { return value.toString(16).padStart(2, '0'); }).join('');
  }

  function getClientSessionId() {
    try {
      var existing = sessionStorage.getItem(SESSION_ID_KEY);
      if (existing) return existing;
      var created = randomId();
      sessionStorage.setItem(SESSION_ID_KEY, created);
      return created;
    } catch (error) {
      return randomId();
    }
  }

  function request(path, options, timeoutMs) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = controller ? setTimeout(function () { controller.abort(); }, timeoutMs || 4500) : null;
    return fetch(BASE_URL + path, Object.assign({}, options || {}, controller ? { signal: controller.signal } : {}))
      .then(function (response) {
        if (!response.ok) throw new Error('size_finder_http_' + response.status);
        if (response.status === 204) return null;
        return response.json();
      })
      .finally(function () { if (timeout) clearTimeout(timeout); });
  }

  function getToken() {
    try {
      var cached = JSON.parse(sessionStorage.getItem(SESSION_TOKEN_KEY) || 'null');
      if (cached && cached.token && Date.parse(cached.expiresAt) > Date.now() + 60000) return Promise.resolve(cached.token);
    } catch (error) {}
    if (tokenPromise) return tokenPromise;
    tokenPromise = request('/v1/session', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ clientSessionId: getClientSessionId() })
    }, 3500).then(function (session) {
      try { sessionStorage.setItem(SESSION_TOKEN_KEY, JSON.stringify(session)); } catch (error) {}
      return session.token;
    }).finally(function () { tokenPromise = null; });
    return tokenPromise;
  }

  function authorizedRequest(path, options, timeoutMs) {
    return getToken().then(function (token) {
      var headers = Object.assign({}, options && options.headers ? options.headers : {}, {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token
      });
      return request(path, Object.assign({}, options || {}, { headers: headers }), timeoutMs);
    });
  }

  function activeRecommendation() {
    try { var value=JSON.parse(sessionStorage.getItem(ACTIVE_KEY) || 'null'); return value && (value.finderType!=='clothing'||value.method==='garment') && location.pathname.split('/products/')[1]?.split('/')[0]===value.productHandle ? value : null; } catch (error) { return null; }
  }

  function setActiveRecommendation(data) {
    try { sessionStorage.setItem(ACTIVE_KEY, JSON.stringify(data)); } catch (error) {}
    try { var p=JSON.parse(document.querySelector('[data-size-product]')?.textContent||'null'); if(p?.handle===data.productHandle){data.variantIds=p.variants.map(function(v){return String(v.id);});sessionStorage.setItem(ACTIVE_KEY,JSON.stringify(data));} } catch(error) {}
    attachToProductForms(data.id);
  }

  function attachToProductForms(recommendationId) {
    var active=activeRecommendation();
    if (!recommendationId || !active || active.id!==recommendationId || (active.finderType==='clothing'&&!active.variantIds)) return;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var input = form.querySelector('input[name="properties[_fate_size_finder_id]"]');
      if(active.variantIds && active.variantIds.indexOf(selectedVariantId(form))<0){if(input)input.remove();return;}
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_fate_size_finder_id]';
        form.appendChild(input);
      }
      input.value = recommendationId;
    });
  }

  function selectedSize(form) {
    try { var product=JSON.parse(document.querySelector('[data-size-product]')?.textContent||'null');
      var variant=product?.variants.find(function(v){return String(v.id)===selectedVariantId(form);});
      var index=product?.options.findIndex(function(o){return /^(size|talla|tamaño)$/i.test(o);});
      if(variant && index>=0)return String(variant.options[index]).trim().toUpperCase().replace(/^2XL$/,'XXL');
    }catch(error){}

    var candidates = document.querySelectorAll('[data-option-value][aria-checked="true"], variant-picker input[type="radio"]:checked, .variant-option__button-label input:checked, .variant-picker__option--selected');
    for (var index = 0; index < candidates.length; index += 1) {
      var value = (candidates[index].getAttribute('data-value') || candidates[index].value || candidates[index].textContent || '').trim().toUpperCase().replace(/\s*MX$/, '');
      if (/^(XS|S|M|L|XL|XXL|2XL|3XL|22|23|24|25|26|27|28|29|30|32|34|36|38)$/.test(value)) return value;
    }
    return null;
  }

  function selectedVariantId(form) {
    var input = form && form.querySelector('[name="id"]');
    return input && input.value ? String(input.value) : undefined;
  }

  function trackCartSelection(form) {
    var active = activeRecommendation();
    if (!active || !active.id || (active.variantIds && active.variantIds.indexOf(selectedVariantId(form))<0)) return;
    var size = selectedSize(form);
    if (!size) return;
    var payload = { recommendationId: active.id, orderedSize: size };
    var variantId = selectedVariantId(form);
    if (variantId) payload.variantId = variantId;
    authorizedRequest('/v1/cart-selection', {
      method: 'PATCH',
      body: JSON.stringify(payload),
      keepalive: true
    }, 3000).catch(function () {});
  }

  function event(eventType, recommendationId, payload) {
    return authorizedRequest('/v1/events', {
      method: 'POST',
      body: JSON.stringify({ eventType: eventType, recommendationId: recommendationId || null, payload: payload || {} }),
      keepalive: true
    }, 2500).catch(function () {});
  }

  document.addEventListener('click', function (clickEvent) {
    var button = clickEvent.target.closest('button[name="add"], button[type="submit"], .product-form__submit, .add-to-cart-button');
    if (!button) return;
    var form = button.closest('form[action*="/cart/add"]');
    if (!form) return;
    var active = activeRecommendation();
    if (active && active.id) attachToProductForms(active.id);
    trackCartSelection(form);
  }, true);

  window.FateSizeFinderAPI = {
    compareGarment: function(payload) {
      return authorizedRequest('/v2/garment-comparisons',{method:'POST',body:JSON.stringify(payload)},6000).then(function(result){
        return result;
      });
    },
    recommend: function (payload) {
      return authorizedRequest('/v1/recommendations', {
        method: 'POST',
        body: JSON.stringify(payload)
      }, 4500).then(function (result) {
        setActiveRecommendation({
          id: result.id,
          recommendedSize: result.recommendedSize,
          finderType: result.finderType,
          productHandle: payload.productHandle
        });
        return result;
      });
    },
    activateGarment: function(result, handle) { if(result.id && location.pathname.split('/products/')[1]?.split('/')[0]===handle) setActiveRecommendation({id:result.id,recommendedSize:result.recommendedSize,finderType:'clothing',method:'garment',productHandle:handle}); },
    event: event,
    attach: attachToProductForms,
    active: activeRecommendation,
    clear: function () {
      try { sessionStorage.removeItem(ACTIVE_KEY); } catch (error) {}
      document.querySelectorAll('input[name="properties[_fate_size_finder_id]"]').forEach(function (input) { input.remove(); });
    }
  };
})();
